<template>
  <div class="logo-component">
    <router-link :to="`/${$i18n.locale}`">
      <img :style="getStyle()" src="/img/logo.png" alt="logo City Aventure">
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "50px"
    }
  },
  methods: {
    getStyle() {
      return {
        width: this.width
      };
    }
  }
};
</script>

<style lang="scss">
.logo-component {
  transition:transform 0.4s;
  transform:scale(1);
  &:hover {
    transform: scale(1.1);
  }
  a {
    cursor:pointer;
  }
}
</style>
